import { Timer } from '@material-ui/icons';
import { Inline } from '@superdispatch/ui';
import { AnchorButton, Box, TextBox } from '@superdispatch/ui-lab';

export function PricingInsightsTransitionBanner() {
  const transitionDate = new Date('2025-12-01');
  const isPostTransition = new Date() > transitionDate;

  if (isPostTransition) {
    window.location.href = 'https://superdispatch.com/pricing-insights-api/';
    return null;
  }

  return (
    <Box padding="small" backgroundColor="Yellow50">
      <Inline horizontalAlign="center" verticalAlign="center" space="xsmall">
        <Timer />
        <TextBox>
          <b>Pricing Insights moves to Shipper TMS on Dec 1, 2025. </b>
          This web version will be discontinued.
        </TextBox>
        <AnchorButton
          target="_blank"
          size="small"
          variant="neutral"
          href="https://superdispatch.com/shipper-request-demo/"
        >
          Contact Sales
        </AnchorButton>
      </Inline>
    </Box>
  );
}
